var _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _feGaussianBlur5, _feGaussianBlur6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackendSystemPortrait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "196.71101mm",
    height: "255.54439mm",
    viewBox: "0 0 196.71101 255.54439",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "a",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur1"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "b",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "c",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur3"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "d",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur4"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "e",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur5"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "g",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-6.644493,-20.727809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-288.39305,367.77087)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a96b8",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 379.61329,-153.09221 18.428,-10.66501 v -7.109 l -4.446,-3.164 -39.707,-11.803 -0.374,17.68 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#274b78",
      fillOpacity: 1,
      strokeWidth: 0.497528,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 355.70668,-261.77823 10.35816,6.81605 11.47816,-7.73702 -9.96617,-6.69317 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20366a",
      fillOpacity: 1,
      strokeWidth: 0.497528,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 355.66423,-228.37316 10.30689,6.91213 0.0943,-33.50115 -10.35875,-6.81605 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c6193",
      fillOpacity: 1,
      strokeWidth: 0.497528,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 377.40919,-229.23595 -11.43748,7.77492 0.0943,-33.50115 11.47757,-7.73702 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#327c97",
      fillOpacity: 1,
      strokeWidth: 0.492698,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 367.18012,-249.18278 v 3.3322 l 9.11262,-5.99182 0.0413,-3.50019 z m 0,-4.2584 v 3.33286 l 9.11262,-5.99248 0.0413,-3.50019 z m 0,8.5168 v 3.3322 l 9.11262,-5.99182 0.0413,-3.50084 z m 0,4.25774 v 3.33286 l 9.11262,-5.99182 0.0413,-3.50084 z m 0,4.25906 v 3.3322 l 9.11262,-5.99248 0.0413,-3.50019 z m 0,4.25774 v 3.33286 l 9.11262,-5.99248 0.0413,-3.50019 z m 0,4.2584 v 3.33221 l 9.11262,-5.99183 0.0413,-3.50019 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b496b",
      fillOpacity: 1,
      strokeWidth: 0.492698,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 364.063,-247.73238 -0.0277,4.34141 -6.35508,-4.15774 -0.0141,-4.51004 z m -0.0142,11.64573 0.0277,2.36353 -6.35508,-4.15709 -0.069,-2.18639 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243764",
      fillOpacity: 1,
      strokeWidth: 0.645805,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 373.60063,-263.54499 -5.45909,-3.77864 -8.48306,5.90228 5.26574,3.69889 z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#275d82",
      fillOpacity: 1,
      strokeWidth: 0.492698,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 371.76325,-263.43257 -3.94238,-2.68054 -6.47238,4.50352 3.69008,2.60667 z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.11828,-168.06591 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.13076
    },
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.793752,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 332.67879,-166.36827 v 34.6879 c 0,0 6.01791,-2.27633 6.14751,-4.89273 0.60422,-12.20576 0.61261,-12.10291 0,-25.40433 -0.11655,-2.51493 -6.14751,-4.39084 -6.14751,-4.39084",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#a)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(0.93243,0,0,1.37128,273.91053,-160.60615)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.974249,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 338.77875,-159.88486 a 10.381676,6.9565034 0 0 1 -10.49823,6.85092 10.381676,6.9565034 0 0 1 -10.26326,-7.00999 10.381676,6.9565034 0 0 1 10.41991,-6.90439 10.381676,6.9565034 0 0 1 10.34251,6.95925",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.11828,-168.06591 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255 m 0,1.46178 c 6.15124,0 10.43949,3.46797 10.43949,6.58077 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46933 -10.43949,-6.5794 0,-3.1128 4.28638,-6.58214 10.43949,-6.58214 m 10.43949,27.04987 v 1.46178 c 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46933 -10.43949,-6.5794 v -2.30786 c 1.78467,2.80564 5.78573,4.76245 10.43949,4.76245 4.65376,0 8.65481,-1.95681 10.43949,-4.76245 v 0.84471 z m 0,-5.84851 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.5794 v -2.21325 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z m 0,-7.31029 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46797 -10.43949,-6.57803 v -2.03773 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.13076
    },
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.747757,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 336.75538,-160.05078 a 8.5317345,4.9873454 0 0 1 -8.62684,4.91055 8.5317345,4.9873454 0 0 1 -8.43383,-5.02437 8.5317345,4.9873454 0 0 1 8.5625,-4.94895 8.5317345,4.9873454 0 0 1 8.4991,4.98735",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 346.92928,-156.57291 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.13076
    },
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.793752,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 351.48979,-154.87527 v 34.6879 c 0,0 6.01791,-2.27632 6.14751,-4.89273 0.60422,-12.20576 0.61261,-12.10291 0,-25.40433 -0.11655,-2.51493 -6.14751,-4.39084 -6.14751,-4.39084",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#b)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(0.93243,0,0,1.37128,292.72153,-149.11315)",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.974249,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 357.58975,-148.39186 a 10.381676,6.9565034 0 0 1 -10.49823,6.85092 10.381676,6.9565034 0 0 1 -10.26326,-7.00999 10.381676,6.9565034 0 0 1 10.41991,-6.90439 10.381676,6.9565034 0 0 1 10.34251,6.95925",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 346.92928,-156.57291 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255 m 0,1.46178 c 6.15124,0 10.43949,3.46797 10.43949,6.58077 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46933 -10.43949,-6.5794 0,-3.1128 4.28638,-6.58214 10.43949,-6.58214 m 10.43949,27.04987 v 1.46178 c 0,3.11144 -4.28732,6.57941 -10.43949,6.57941 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.57941 v -2.30786 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 v 0.84471 z m 0,-5.84851 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.5794 v -2.21325 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z m 0,-7.31029 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46797 -10.43949,-6.57803 v -2.03773 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.13076
    },
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.747757,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 355.56638,-148.55778 a 8.5317345,4.9873454 0 0 1 -8.62684,4.91055 8.5317345,4.9873454 0 0 1 -8.43383,-5.02437 8.5317345,4.9873454 0 0 1 8.5625,-4.94895 8.5317345,4.9873454 0 0 1 8.4991,4.98735",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 309.30528,-156.16191 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.13076
    },
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.793752,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 313.86579,-154.46427 v 34.6879 c 0,0 6.01791,-2.27632 6.14751,-4.89273 0.60422,-12.20576 0.61261,-12.10291 0,-25.40433 -0.11655,-2.51493 -6.14751,-4.39084 -6.14751,-4.39084",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#c)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(0.93243,0,0,1.37128,255.09753,-148.70215)",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.974249,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 319.96575,-147.98086 a 10.381676,6.9565034 0 0 1 -10.49823,6.85092 10.381676,6.9565034 0 0 1 -10.26326,-7.00999 10.381676,6.9565034 0 0 1 10.41991,-6.90439 10.381676,6.9565034 0 0 1 10.34251,6.95925",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 309.30528,-156.16191 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255 m 0,1.46178 c 6.15124,0 10.43949,3.46797 10.43949,6.58077 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46933 -10.43949,-6.5794 0,-3.1128 4.28638,-6.58214 10.43949,-6.58214 m 10.43949,27.04987 v 1.46178 c 0,3.11144 -4.28732,6.57941 -10.43949,6.57941 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.57941 v -2.30786 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 v 0.84471 z m 0,-5.84851 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.5794 v -2.21325 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z m 0,-7.31029 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46797 -10.43949,-6.57803 v -2.03773 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.13076
    },
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.747757,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 317.94238,-148.14678 a 8.5317345,4.9873454 0 0 1 -8.62684,4.91055 8.5317345,4.9873454 0 0 1 -8.43383,-5.02437 8.5317345,4.9873454 0 0 1 8.5625,-4.94895 8.5317345,4.9873454 0 0 1 8.4991,4.98735",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.29028,-145.07691 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.13076
    },
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.793752,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 332.85079,-143.37927 v 34.6879 c 0,0 6.01791,-2.27632 6.14751,-4.89273 0.60422,-12.20576 0.61261,-12.10291 0,-25.40433 -0.11655,-2.51493 -6.14751,-4.39084 -6.14751,-4.39084",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#d)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(0.93243,0,0,1.37128,274.08253,-137.61715)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.974249,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 338.95075,-136.89586 a 10.381676,6.9565034 0 0 1 -10.49823,6.85092 10.381676,6.9565034 0 0 1 -10.26326,-7.00999 10.381676,6.9565034 0 0 1 10.41991,-6.90439 10.381676,6.9565034 0 0 1 10.34251,6.95925",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.29028,-145.07691 c -6.31442,0 -11.43346,3.60098 -11.43346,8.04255 v 21.93226 c 0,4.4402 5.11904,8.04118 11.43346,8.04118 6.31348,0 11.43346,-3.60098 11.43346,-8.04118 v -21.93226 c 0,-4.44294 -5.11905,-8.04255 -11.43346,-8.04255 m 0,1.46178 c 6.15124,0 10.43949,3.46797 10.43949,6.58077 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46933 -10.43949,-6.5794 0,-3.1128 4.28638,-6.58214 10.43949,-6.58214 m 10.43949,27.04987 v 1.46178 c 0,3.11144 -4.28732,6.57941 -10.43949,6.57941 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.57941 v -2.30786 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 v 0.84471 z m 0,-5.84851 c 0,3.11144 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46934 -10.43949,-6.5794 v -2.21325 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z m 0,-7.31029 c 0,3.11143 -4.28732,6.5794 -10.43949,6.5794 -6.15217,0 -10.43949,-3.46797 -10.43949,-6.57803 v -2.03773 c 1.78467,2.80564 5.78573,4.76246 10.43949,4.76246 4.65376,0 8.65481,-1.95682 10.43949,-4.76246 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.13076
    },
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.747757,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 336.92738,-137.06178 a 8.5317345,4.9873454 0 0 1 -8.62684,4.91055 8.5317345,4.9873454 0 0 1 -8.43383,-5.02437 8.5317345,4.9873454 0 0 1 8.5625,-4.94895 8.5317345,4.9873454 0 0 1 8.4991,4.98735",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 312.26295,-264.78135 c -9.47856,0 -17.16275,5.40543 -17.16275,12.07269 v 9.95457 c 0,6.66519 7.68419,12.07063 17.16275,12.07063 9.47717,0 17.16275,-5.40544 17.16275,-12.07063 v -9.95457 c 0,-6.66932 -7.68418,-12.07269 -17.16275,-12.07269",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.69739
    },
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 1.46244,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 328.26398,-252.50076 a 15.583926,10.442415 0 0 1 -15.75749,10.28392 15.583926,10.442415 0 0 1 -15.40616,-10.51858 15.583926,10.442415 0 0 1 15.64131,-10.36626 15.583926,10.442415 0 0 1 15.52514,10.44242",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 312.26295,-264.78135 c -9.47856,0 -17.16275,5.40543 -17.16275,12.07269 v 21.46325 c -0.0686,-1.31122 34.3255,9.21765 34.3255,-21.46325 0,-6.66726 -7.68418,-12.07269 -17.16275,-12.07269 m 0,2.19428 c 9.23362,0 15.67071,5.20577 15.67071,9.87841 0,4.67058 -6.43569,9.87635 -15.67071,9.87635 -9.23502,0 -15.6707,-5.20577 -15.6707,-9.87635 0,-4.67058 6.43428,-9.87841 15.6707,-9.87841 m -15.6707,20.8519 v -3.05677 c 2.67896,4.21155 8.68495,7.14893 15.6707,7.14893 6.98575,0 12.99174,-2.93738 15.67071,-7.14893 -6.97036,23.55873 -31.34141,12.59759 -31.34141,3.05677",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.69739
    },
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.12246,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 325.22669,-252.74983 a 12.806981,7.4865099 0 0 1 -12.94834,7.37124 12.806981,7.4865099 0 0 1 -12.66002,-7.54209 12.806981,7.4865099 0 0 1 12.85317,-7.42887 12.806981,7.4865099 0 0 1 12.75799,7.48651",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 450.89519,-183.75857 c -7.06455,0 -12.79172,4.02878 -12.79172,8.99802 v 24.53784 c 0,4.96771 5.72717,8.99649 12.79172,8.99649 7.0635,0 12.79172,-4.02878 12.79172,-8.99649 v -24.53784 c 0,-4.97077 -5.72717,-8.99802 -12.79172,-8.99802",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.2651
    },
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.888049,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 455.99748,-181.85924 v 38.80887 c 0,0 6.73281,-2.54676 6.87782,-5.47399 0.67599,-13.65583 0.68538,-13.54076 0,-28.42241 -0.1304,-2.8137 -6.87782,-4.91247 -6.87782,-4.91247",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#e)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(1.0432,0,0,1.53419,390.24771,-175.41258)",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 1.08999,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 462.82209,-174.60559 a 11.614989,7.7829459 0 0 1 -11.74539,7.66481 11.614989,7.7829459 0 0 1 -11.4825,-7.84278 11.614989,7.7829459 0 0 1 11.65776,-7.72464 11.614989,7.7829459 0 0 1 11.57118,7.78601",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 450.89519,-183.75857 c -7.06455,0 -12.79172,4.02878 -12.79172,8.99802 v 24.53784 c 0,4.96771 5.72717,8.99649 12.79172,8.99649 7.0635,0 12.79172,-4.02878 12.79172,-8.99649 v -24.53784 c 0,-4.97077 -5.72717,-8.99802 -12.79172,-8.99802 m 0,1.63545 c 6.88199,0 11.67966,3.87996 11.67966,7.36257 0,3.48108 -4.79663,7.36105 -11.67966,7.36105 -6.88304,0 -11.67967,-3.8815 -11.67967,-7.36105 0,-3.48261 4.79559,-7.36411 11.67967,-7.36411 m 11.67966,30.26343 v 1.63545 c 0,3.48108 -4.79663,7.36104 -11.67966,7.36104 -6.88304,0 -11.67967,-3.8815 -11.67967,-7.36104 v -2.58204 c 1.99668,3.13895 6.47306,5.32824 11.67967,5.32824 5.20661,0 9.68298,-2.18929 11.67966,-5.32824 v 0.94506 z m 0,-6.54332 c 0,3.48108 -4.79663,7.36105 -11.67966,7.36105 -6.88304,0 -11.67967,-3.8815 -11.67967,-7.36105 v -2.47618 c 1.99668,3.13895 6.47306,5.32824 11.67967,5.32824 5.20661,0 9.68298,-2.18929 11.67966,-5.32824 z m 0,-8.17876 c 0,3.48107 -4.79663,7.36104 -11.67966,7.36104 -6.88304,0 -11.67967,-3.87997 -11.67967,-7.35951 v -2.2798 c 1.99668,3.13895 6.47306,5.32824 11.67967,5.32824 5.20661,0 9.68298,-2.18929 11.67966,-5.32824 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.2651
    },
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.83659,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 460.55835,-174.79123 a 9.54528,5.579849 0 0 1 -9.65169,5.49394 9.54528,5.579849 0 0 1 -9.43574,-5.62128 9.54528,5.579849 0 0 1 9.5797,-5.53689 9.54528,5.579849 0 0 1 9.50877,5.57985",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 480.3151,-181.88785 c -6.31441,0 -11.43345,3.60098 -11.43345,8.04256 v 21.93225 c 0,4.4402 5.11904,8.04119 11.43345,8.04119 6.31349,0 11.43346,-3.60099 11.43346,-8.04119 v -21.93225 c 0,-4.44295 -5.11904,-8.04256 -11.43346,-8.04256",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 1.13076
    },
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.793752,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 484.87562,-180.1902 v 34.68789 c 0,0 6.0179,-2.27632 6.14751,-4.89272 0.60421,-12.20577 0.6126,-12.10292 0,-25.40434 -0.11656,-2.51492 -6.14751,-4.39083 -6.14751,-4.39083",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#g)"
    },
    d: "m 63.503,-4.54 v 26.092 h -5.92 V -4.697 Z",
    transform: "matrix(0.93243,0,0,1.37128,426.10735,-174.42809)",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.974249,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 490.97557,-173.70679 a 10.381676,6.9565034 0 0 1 -10.49823,6.85091 10.381676,6.9565034 0 0 1 -10.26325,-7.00998 10.381676,6.9565034 0 0 1 10.4199,-6.9044 10.381676,6.9565034 0 0 1 10.34252,6.95925",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 480.3151,-181.88785 c -6.31441,0 -11.43345,3.60098 -11.43345,8.04256 v 21.93225 c 0,4.4402 5.11904,8.04119 11.43345,8.04119 6.31349,0 11.43346,-3.60099 11.43346,-8.04119 v -21.93225 c 0,-4.44295 -5.11904,-8.04256 -11.43346,-8.04256 m 0,1.46179 c 6.15124,0 10.43949,3.46796 10.43949,6.58077 0,3.11143 -4.28731,6.5794 -10.43949,6.5794 -6.15217,0 -10.43948,-3.46934 -10.43948,-6.5794 0,-3.11281 4.28638,-6.58215 10.43948,-6.58215 m 10.43949,27.04987 v 1.46179 c 0,3.11143 -4.28731,6.5794 -10.43949,6.5794 -6.15217,0 -10.43948,-3.46934 -10.43948,-6.5794 v -2.30787 c 1.78467,2.80564 5.78572,4.76246 10.43948,4.76246 4.65376,0 8.65482,-1.95682 10.43949,-4.76246 v 0.84471 z m 0,-5.84851 c 0,3.11144 -4.28731,6.57941 -10.43949,6.57941 -6.15217,0 -10.43948,-3.46934 -10.43948,-6.57941 v -2.21324 c 1.78467,2.80564 5.78572,4.76245 10.43948,4.76245 4.65376,0 8.65482,-1.95681 10.43949,-4.76245 z m 0,-7.31029 c 0,3.11143 -4.28731,6.5794 -10.43949,6.5794 -6.15217,0 -10.43948,-3.46797 -10.43948,-6.57803 v -2.03772 c 1.78467,2.80564 5.78572,4.76246 10.43948,4.76246 4.65376,0 8.65482,-1.95682 10.43949,-4.76246 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.13076
    },
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.747757,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 488.9522,-173.87272 a 8.5317345,4.9873454 0 0 1 -8.62684,4.91056 8.5317345,4.9873454 0 0 1 -8.43383,-5.02437 8.5317345,4.9873454 0 0 1 8.5625,-4.94895 8.5317345,4.9873454 0 0 1 8.4991,4.98734",
    id: "path60"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.98719,-130.66342)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47c0d3",
      fillOpacity: 1,
      strokeWidth: 0.591942,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m -0.16,-82.687 30.97,17.513 c 1.67,0.945 2.128,3.877 0.489,4.874 L 18.3,-52.394 c -1.64,0.997 -3.215,1.453 -4.874,0.49 l -30.362,-17.644 c -1.659,-0.964 -2.114,-3.854 -0.489,-4.874 l 12.39,-7.776 c 1.626,-1.02 3.204,-1.434 4.874,-0.49",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2990ce",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 0.118,-82.81 -19.008,11.763 -0.972,-2.227 17.5,-10.852 z",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.650192,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m -2.394,-84.335 c -1.113,-0.021 -2.21,0.422 -3.326,1.123 l -13.61,8.54 c -1.784,1.121 -1.285,4.295 0.538,5.354 l 33.35,19.38 c 1.822,1.06 3.614,0.653 5.353,-0.537 l 13.255,-9.074 c 1.74,-1.19 1.293,-4.308 -0.538,-5.353 L -0.366,-83.75 c -0.686,-0.392 -1.36,-0.572 -2.028,-0.585 m 0.388,1.115 c 0.608,0.012 1.22,0.176 1.846,0.533 l 30.88,17.469 c 1.667,0.952 2.074,3.79 0.49,4.874 l -12.91,7.95 c -1.583,1.084 -3.215,1.453 -4.874,0.49 l -30.362,-17.644 c -1.659,-0.964 -2.114,-3.854 -0.489,-4.874 l 12.39,-7.776 c 1.016,-0.638 2.016,-1.041 3.029,-1.022",
    id: "path63"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      strokeWidth: 0.641011,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    width: 3.681,
    height: 0.66500002,
    x: -45.319,
    y: -51.500999,
    ry: 0.333,
    transform: "rotate(29.987)",
    id: "rect63"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#333333",
      fillOpacity: 1,
      strokeWidth: 0.445322,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    width: 2.5580001,
    height: 0.46200001,
    x: 32.007999,
    y: -72.889999,
    ry: 0.23100001,
    transform: "rotate(-32.547)",
    id: "rect64"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1
    },
    id: "g80-1",
    transform: "matrix(-1,0,0,1,529.03631,-358.838)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m -17.938,-65.29 c -8.134,-0.038 -20.642,16.132 -18.38,25.52 -4.87,-0.518 -11.297,13.254 -14.814,19.217 -0.823,1.396 7.96,10.044 12.108,10.06 2.831,0.04 44.292,-27.326 44.292,-27.326 4.503,-3.767 5.545,-7.984 4.757,-13.263 -1.165,-3.904 -6.972,-5.608 -9.419,-4.287 -0.848,-5.861 -7.007,-2.033 -9.343,-0.465 0.342,-5.64 -4.356,-9.435 -9.201,-9.457",
    transform: "matrix(1.18102,0,0,1.218,118.4,98.372)",
    id: "path80-5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 409.17831,-326.411 c 0,0 -1.323,-0.897 -2.09,-1.116 -0.823,-0.237 -2.68,-0.253 -2.68,-0.253 0,0 10.905,-6.996 16.23,-9.658 1.08,-0.54 3.624,-0.14 3.624,-0.14 0,0 2.457,-2.153 4.014,-2.72 1.174,-0.428 5.394,-0.13 5.394,-0.13 -1.07,2.434 -9.163,3.744 -11.611,7.955 -0.427,1.245 -1.094,4.829 -1.094,4.829 0,0 -5.66,-3.294 -8.447,-2.47 -1.677,0.494 -3.34,3.702 -3.34,3.702",
    id: "path81-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 430.29231,-333.973 c 5.642,-0.025 17.94,12.42 16.953,26.237 -0.028,0.404 -0.083,0.757 -0.158,1.07 a 4,4 0 0 1 0.38,-0.026 c 5.213,-0.024 15.195,12.856 15.234,19.14 0.04,6.284 -1.014,11.022 -6.227,11.093 -2.831,0.039 -49.388,-30.042 -49.388,-30.042 -4.503,-3.767 -5.546,-7.984 -4.757,-13.263 1.837,-6.945 6.188,-4.413 8.634,-3.092 0.96,-9.011 8.576,-3.554 12.144,-0.249 -1.014,-7.92 2.34,-10.846 7.185,-10.868",
    id: "path82-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcddea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 425.45231,-335.663 c -2.138,0.971 19.328,-11.412 19.77,-11.38 9.002,0.664 27.226,25.446 18.848,32.713 0,0 -12.895,5.018 -13.052,3.845 -1.615,-13.185 -13.342,-30.735 -25.566,-25.178",
    id: "path83-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accfe3",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 451.12631,-310.384 12.915,-7.667 c 0.416,-0.247 1.605,-0.927 2.047,-0.968 7.972,-0.74 21.626,27.293 11.612,33.578 0,0 -15.687,10.707 -15.114,9.36 8.87,-20.877 -11.46,-34.303 -11.46,-34.303",
    id: "path84-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1d1e6",
      fillOpacity: 1,
      strokeWidth: 0.691903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 455.64738,-218.82071 30.897,17.868 c 1.809,1.046 1.103,4.143 -0.71,5.179 l -18.359,10.49 c -1.814,1.036 -3.52,1.555 -5.311,0.479 l -29.49,-17.72 c -1.79,-1.076 -2.287,-4.264 -0.48,-5.311 l 18.141,-10.506 c 1.808,-1.047 3.503,-1.525 5.312,-0.48",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      fillOpacity: 1,
      strokeWidth: 0.337346,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 453.93238,-216.69771 28.558,16.781 c 0.878,0.516 0.538,2.02 -0.347,2.525 l -8.95,5.115 c -0.885,0.505 -1.717,0.757 -2.59,0.233 l -27.872,-16.709 c -0.873,-0.523 -1.115,-2.079 -0.234,-2.59 l 8.845,-5.122 c 0.881,-0.51 1.711,-0.75 2.59,-0.233",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      fillOpacity: 1,
      strokeWidth: 0.17865,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 449.56538,-202.81071 8.81,5.1 c 0.466,0.27 0.284,1.07 -0.184,1.337 l -4.74,2.708 c -0.469,0.268 -0.909,0.401 -1.372,0.124 l -8.446,-5.06 c -0.462,-0.278 -0.59,-1.101 -0.123,-1.372 l 4.684,-2.712 c 0.466,-0.27 0.906,-0.397 1.37,-0.124",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23334d",
      fillOpacity: 1,
      strokeWidth: 0.691903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 455.01438,-219.01271 30.914,18.97 c 1.78,1.092 3.615,-0.622 3.602,-2.71 l -0.133,-21.443 c -0.013,-2.089 0.387,-3.222 -1.4,-4.304 l -31.2,-18.876 c -1.787,-1.081 -3.896,-0.36 -3.882,1.728 l 0.137,21.676 c 0.013,2.09 0.181,3.867 1.962,4.96",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46bdd6",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 456.21938,-219.96871 c 3.506,1.562 30.628,18.38 30.628,18.38 l 0.03,-21.887 c 0.002,-1.614 0.306,-2.501 -1.082,-3.324 l -31.109,-18.45 c 0,0 -0.006,17.82 0.017,21.45 0.01,1.614 0.14,2.987 1.516,3.831",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1cee0",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 353.30212,-270.04174 c -0.49,-0.002 -10.978,6.095 -22.497,12.875 -12.026,6.813 -25.922,14.827 -33.202,19.528 -2.868,1.852 -2.501,6.394 -2.501,6.394 0,0 -0.343,26.31 0.552,38.511 0.093,1.262 2.094,2.277 3.241,2.282 0.49,0.002 10.987,-6.1 22.513,-12.884 12.022,-6.81 25.91,-14.82 33.187,-19.518 2.867,-1.852 2.5,-6.394 2.5,-6.394 0,0 0.344,-26.31 -0.552,-38.512 -0.092,-1.262 -2.093,-2.277 -3.24,-2.282",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 300.68512,-197.10574 0.023,-37.699 52.67,-30.565 -0.49,38.014 z",
    id: "path96"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1
    },
    id: "g97",
    transform: "translate(27.073016,-293.69862)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m -17.938,-65.29 c -8.134,-0.038 -20.642,16.132 -18.38,25.52 -4.87,-0.518 -11.297,13.254 -14.814,19.217 -0.823,1.396 7.96,10.044 12.108,10.06 2.831,0.04 44.292,-27.326 44.292,-27.326 4.503,-3.767 5.545,-7.984 4.757,-13.263 -1.165,-3.904 -6.972,-5.608 -9.419,-4.287 -0.848,-5.861 -7.007,-2.033 -9.343,-0.465 0.342,-5.64 -4.356,-9.435 -9.201,-9.457",
    transform: "matrix(-0.35533,0,0,0.36646,435.515,86.893)",
    id: "path97"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.238816,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 462.14917,-226.64628 c 0,0 -0.39806,-0.26988 -0.62882,-0.33577 -0.24762,-0.0713 -0.80633,-0.0761 -0.80633,-0.0761 0,0 3.28098,-2.10489 4.88312,-2.90581 0.32494,-0.16247 1.09035,-0.0421 1.09035,-0.0421 0,0 0.73924,-0.64777 1.20769,-0.81836 0.35322,-0.12878 1.62289,-0.0391 1.62289,-0.0391 -0.32193,0.73232 -2.75687,1.12646 -3.4934,2.39342 -0.12847,0.37459 -0.32915,1.4529 -0.32915,1.4529 0,0 -1.70292,-0.99106 -2.54145,-0.74314 -0.50456,0.14863 -1.0049,1.11382 -1.0049,1.11382",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.205766,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 468.50174,-228.92146 c 1.6975,-0.008 5.3976,3.7368 5.10064,7.89392 -0.008,0.12156 -0.025,0.22776 -0.0475,0.32194 a 1.20348,1.20348 0 0 1 0.11433,-0.008 c 1.56843,-0.007 4.57172,3.86799 4.58345,5.75865 0.012,1.89067 -0.30508,3.31619 -1.87352,3.33756 -0.85176,0.0117 -14.85936,-9.03874 -14.85936,-9.03874 -1.35482,-1.13338 -1.66863,-2.40215 -1.43124,-3.99044 0.5527,-2.08954 1.86178,-1.32774 2.59771,-0.93029 0.28883,-2.71114 2.58026,-1.06929 3.65376,-0.0749 -0.30508,-2.38289 0.70404,-3.26323 2.16176,-3.26985",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcddea",
      fillOpacity: 1,
      strokeWidth: 0.238816,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 467.04552,-229.42993 c -0.64326,0.29214 3.50033,-2.1106 3.63331,-2.10068 2.70843,0.19918 8.19119,7.65564 5.6705,9.84206 0,0 -1.56453,0.18684 -1.61176,-0.16608 -0.48591,-3.96697 -4.01421,-9.24724 -7.69205,-7.5753",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accfe3",
      fillOpacity: 1,
      strokeWidth: 0.238816,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 474.77006,-221.82424 1.37197,-1.01694 c 0.11734,-0.0867 0.4832,-0.27891 0.61588,-0.29124 2.39884,-0.22265 6.50691,8.21164 3.494,10.10261 0,0 -2.20628,1.93159 -2.03388,1.52601 2.66872,-6.28096 -3.44797,-10.32044 -3.44797,-10.32044",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.321913,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 328.64163,-242.32963 c -2.65569,-0.0122 -8.44435,5.84609 -7.97977,12.34928 0.0136,0.19064 0.0395,0.35679 0.0748,0.50365 a 1.8828,1.8828 0 0 0 -0.17934,-0.0118 c -2.45376,-0.0113 -7.15182,6.05179 -7.17064,9.0092 -0.0188,2.95741 0.47776,5.18806 2.93105,5.22148 1.33302,0.0183 23.24693,-14.14077 23.24693,-14.14077 2.11956,-1.77313 2.6105,-3.75807 2.23912,-6.24243 -0.86468,-3.26948 -2.91269,-2.07767 -4.06403,-1.45587 -0.45187,-4.24101 -4.03672,-1.67287 -5.71618,-0.11673 0.47729,-3.72795 -1.10144,-5.10569 -3.38198,-5.11604 m -0.18922,1.88609 c 2.03813,0.009 3.44929,1.23983 3.02237,4.57191 1.50153,-1.39092 5.36645,-3.88469 5.77031,-0.0941 1.02942,-0.55542 2.85903,-1.62062 3.63239,1.30102 0.33137,2.22076 -0.10685,3.13486 -2.00095,4.71971 0,0 -20.24763,12.85293 -21.43897,12.83693 -2.19252,-0.0301 -2.63592,-1.16357 -2.61944,-3.80703 0.0165,-2.64345 4.33279,-7.82774 6.52578,-7.81832 0.0546,4.7e-4 0.10779,0.006 0.16004,0.0113 a 2.8242,2.8242 0 0 1 -0.0664,-0.45046 c -0.41516,-5.8122 4.6411,-11.28173 7.01484,-11.27091",
    id: "path102"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g103",
    transform: "translate(295.03712,-361.57674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 11.243,10.918 a 0.5,0.5 0 0 1 0.23,-0.535 0.34,0.34 0 0 1 0.304,-0.03 L 11.76,10.306 a 0.05,0.05 0 0 1 0.023,-0.058 c 0.02,-0.012 0.042,-0.005 0.05,0.016 l 0.054,0.15 a 0.05,0.05 0 0 1 -0.001,0.032 0.05,0.05 0 0 1 -0.022,0.026 l -0.144,0.083 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 a 0.05,0.05 0 0 1 0.023,-0.058 l 0.067,-0.04 a 0.27,0.27 0 0 0 -0.26,0.016 0.4,0.4 0 0 0 -0.182,0.427 0.05,0.05 0 0 1 -0.028,0.057 C 11.27,10.95 11.249,10.94 11.243,10.918 m 0.7,-0.356 c 0.02,-0.01 0.041,0 0.047,0.022 a 0.5,0.5 0 0 1 -0.23,0.536 0.34,0.34 0 0 1 -0.304,0.03 l 0.017,0.046 a 0.05,0.05 0 0 1 -0.022,0.058 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 l -0.054,-0.15 a 0.05,0.05 0 0 1 0,-0.032 0.05,0.05 0 0 1 0.022,-0.025 l 0.144,-0.084 c 0.02,-0.012 0.042,-0.005 0.05,0.016 a 0.05,0.05 0 0 1 -0.023,0.058 l -0.067,0.04 a 0.27,0.27 0 0 0 0.26,-0.016 0.4,0.4 0 0 0 0.182,-0.427 0.05,0.05 0 0 1 0.028,-0.056",
    fill: "#0f1729",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.040354
    },
    transform: "matrix(8.81935,0,0,8.81935,-69.105,36.779)",
    id: "path103"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g103-2",
    transform: "matrix(3.0127512,0,0,-3.0127512,330.58075,87.2759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 11.243,10.918 a 0.5,0.5 0 0 1 0.23,-0.535 0.34,0.34 0 0 1 0.304,-0.03 L 11.76,10.306 a 0.05,0.05 0 0 1 0.023,-0.058 c 0.02,-0.012 0.042,-0.005 0.05,0.016 l 0.054,0.15 a 0.05,0.05 0 0 1 -0.001,0.032 0.05,0.05 0 0 1 -0.022,0.026 l -0.144,0.083 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 a 0.05,0.05 0 0 1 0.023,-0.058 l 0.067,-0.04 a 0.27,0.27 0 0 0 -0.26,0.016 0.4,0.4 0 0 0 -0.182,0.427 0.05,0.05 0 0 1 -0.028,0.057 C 11.27,10.95 11.249,10.94 11.243,10.918 m 0.7,-0.356 c 0.02,-0.01 0.041,0 0.047,0.022 a 0.5,0.5 0 0 1 -0.23,0.536 0.34,0.34 0 0 1 -0.304,0.03 l 0.017,0.046 a 0.05,0.05 0 0 1 -0.022,0.058 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 l -0.054,-0.15 a 0.05,0.05 0 0 1 0,-0.032 0.05,0.05 0 0 1 0.022,-0.025 l 0.144,-0.084 c 0.02,-0.012 0.042,-0.005 0.05,0.016 a 0.05,0.05 0 0 1 -0.023,0.058 l -0.067,0.04 a 0.27,0.27 0 0 0 0.26,-0.016 0.4,0.4 0 0 0 0.182,-0.427 0.05,0.05 0 0 1 0.028,-0.056",
    fill: "#0f1729",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.040354
    },
    transform: "matrix(8.81935,0,0,8.81935,-69.105,36.779)",
    id: "path103-1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g103-2-6",
    transform: "matrix(0.74942009,0,0,-0.74942009,444.01134,-122.87822)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 11.243,10.918 a 0.5,0.5 0 0 1 0.23,-0.535 0.34,0.34 0 0 1 0.304,-0.03 L 11.76,10.306 a 0.05,0.05 0 0 1 0.023,-0.058 c 0.02,-0.012 0.042,-0.005 0.05,0.016 l 0.054,0.15 a 0.05,0.05 0 0 1 -0.001,0.032 0.05,0.05 0 0 1 -0.022,0.026 l -0.144,0.083 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 a 0.05,0.05 0 0 1 0.023,-0.058 l 0.067,-0.04 a 0.27,0.27 0 0 0 -0.26,0.016 0.4,0.4 0 0 0 -0.182,0.427 0.05,0.05 0 0 1 -0.028,0.057 C 11.27,10.95 11.249,10.94 11.243,10.918 m 0.7,-0.356 c 0.02,-0.01 0.041,0 0.047,0.022 a 0.5,0.5 0 0 1 -0.23,0.536 0.34,0.34 0 0 1 -0.304,0.03 l 0.017,0.046 a 0.05,0.05 0 0 1 -0.022,0.058 c -0.02,0.012 -0.042,0.005 -0.05,-0.016 l -0.054,-0.15 a 0.05,0.05 0 0 1 0,-0.032 0.05,0.05 0 0 1 0.022,-0.025 l 0.144,-0.084 c 0.02,-0.012 0.042,-0.005 0.05,0.016 a 0.05,0.05 0 0 1 -0.023,0.058 l -0.067,0.04 a 0.27,0.27 0 0 0 0.26,-0.016 0.4,0.4 0 0 0 0.182,-0.427 0.05,0.05 0 0 1 0.028,-0.056",
    fill: "#0f1729",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.040354
    },
    transform: "matrix(8.81935,0,0,8.81935,-69.105,36.779)",
    id: "path103-1-1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#274b78",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 398.8017,-153.18068 17.572,10.428 19.472,-11.837 -16.907,-10.24 z",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20366a",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 398.7297,-102.07368 17.485,10.575002 0.16,-51.254002 -17.573,-10.428 z",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c6193",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 435.6187,-103.39368 -19.403,11.895002 0.16,-51.254002 19.471,-11.837 z",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#327c97",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 418.2657,-133.91068 v 5.098 l 15.459,-9.167 0.07,-5.355 z m 0,-6.515 v 5.099 l 15.459,-9.168 0.07,-5.355 z m 0,13.03 v 5.098 l 15.459,-9.167 0.07,-5.356 z m 0,6.514 v 5.099 l 15.459,-9.167 0.07,-5.356 z m 0,6.516 v 5.098 l 15.459,-9.168 0.07,-5.355 z m 0,6.514 v 5.099 l 15.459,-9.168 0.07,-5.355 z m 0,6.515 v 5.098002 l 15.459,-9.167002 0.07,-5.355 z",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b496b",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 412.9777,-131.69168 -0.047,6.642 -10.781,-6.361 -0.024,-6.9 z m -0.024,17.817 0.047,3.616 -10.781,-6.36 -0.117,-3.345 z",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#243764",
      fillOpacity: 1,
      strokeWidth: 1.04041,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 429.1577,-155.88368 -9.261,-5.781 -14.391,9.03 8.933,5.659 z",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#275d82",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 426.0407,-155.71168 -6.688,-4.101 -10.98,6.89 6.26,3.988 z",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2d1e3",
      fillOpacity: 1,
      strokeWidth: 0.871724,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 345.62712,-197.92974 a 11.08,7.54 0 0 1 -11.204,7.426 11.08,7.54 0 0 1 -10.954,-7.597 11.08,7.54 0 0 1 11.121,-7.484 11.08,7.54 0 0 1 11.038,7.541",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263b56",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 340.26812,-214.17174 -2.115,11.828 -9.326,5.49 1.687,-11.718 z",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#152149",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 330.60712,-208.61874 -1.78,11.766 -2.514,-1.654 1.128,-8.297 z",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9b949",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 311.73312,-272.56474 0.066,19.05 2.514,1.587 19.116,-12.038 -0.133,-16.67 -1.455,0.067 -0.463,-0.595 0.199,-1.522 -12.171,7.012 -1.058,-0.926 z",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6f1de",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 312.42712,-254.27574 1.409,0.973 -0.26,-16.757 18.315,-10.46 -0.513,-0.66 -18.89,10.372 z",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#346289",
      fillOpacity: 1,
      strokeWidth: 0.783005,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 447.33429,-130.58425 20.66,12.38199 20.593,-12.32499 -21.397,-12.39 z",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283467",
      fillOpacity: 1,
      strokeWidth: 0.644937,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 447.07529,-103.93026 20.946,11.992001 -0.028,-26.264001 -20.659,-12.38299 z",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d7294",
      fillOpacity: 1,
      strokeWidth: 0.523939,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 488.58729,-104.09026 -20.566,12.152001 -0.028,-26.264001 20.594,-12.32499 z",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a3062",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 487.40529,-107.25126 v -5.174 l -17.429,10.165 v 5.269001 z m -0.065,-13.55399 v -5.175 l -17.428,9.80199 v 5.632 z",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385f8a",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 448.77329,-111.85926 -0.028,-7.06999 16.74,9.33299 0.014,6.905 z m 0,-8.13299 -0.028,-7.07 16.74,9.33299 0.014,6.904 z m 0,16.26699 -0.028,-7.07 16.74,9.332 0.014,6.905001 z",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a3062",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 487.34029,-114.05726 v -5.17399 l -17.428,10.16499 v 5.268 z",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#325e85",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 380.17429,-169.93122 v 7.297 l 18.054,-10.477 -0.187,-7.39 z",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34537c",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 380.36129,-160.20221 v 7.016 l 17.68,-10.57001 v -7.11 z",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d3b68",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 379.61329,-162.77422 v -6.782 l -25.632,-15.716 v 7.577 z",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e4b7b",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 379.61329,-160.20221 v 7.11 l -26.1,-15.06101 -0.093,-8.139 z",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32567a",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 353.88829,-185.83322 18.335,-9.822 25.818,15.154 -17.867,10.57 z",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50869f",
      fillOpacity: 1,
      strokeWidth: 0.419503,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m 378.59529,-159.33021 v 4.26 l -23.976,-13.92001 -0.056,-4.877 z m 0.336,-9.35701 v 4.26 l -23.975,-13.92 -0.056,-4.878 z",
    id: "path127"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendSystemPortrait);
export default __webpack_public_path__ + "static/media/backend-system-portrait.576f3cb8941e5ab0f12d4c3e6a9fdaaf.svg";
export { ForwardRef as ReactComponent };